import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { User } from '../entity/user.interface';

interface UserState {
  user: User | undefined;
  isInitialized: boolean;
}

export type UserStore = InstanceType<typeof UserStore>;

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState<UserState>({
    user: undefined,
    isInitialized: false,
  }),
  withComputed((store) => {
    // Vérifie si l'utilisateur existe et s'il est un utilisateur Google
    const isGoogleUser = computed(() => !!store.user()?.email?.endsWith('@google.com'));
    return { isGoogleUser };
  }),
  withMethods((store) => ({
    // Charger un utilisateur dans l'état
    load(user: User): void {
      patchState(store, { user, isInitialized: true });
    },
    // Réinitialiser l'état de l'utilisateur (logout)
    clear(): void {
      patchState(store, { user: undefined, isInitialized: true });
    },
    // Marquer l'initialisation comme terminée (même sans utilisateur)
    markInitialized(): void {
      patchState(store, { isInitialized: true });
    },
  })),
);
